

import React, { useEffect, useState } from 'react';
import { ContractReleases } from '../Contracts/contractReleases';
import WizardServices from './WizardServices';
import { ContractTrackMain } from '../Contracts/contractTrackMain';
import { ContractLinkSong } from '../Contracts/contractLinkSong';
import { CommonUtilities } from '../../commonUtils';
import ContractAssetLink from 'components/MetaData/contractAssetLink';

export function ContractWizardSummary(MainWizard: any) {

    let [close, setClose] = useState(false);
    let [contractStatus, setcontractStatus] = useState("");
    let [openContractSong, setopenContractSong] = useState(false);
    let [conAdditional, setcontractAdditional] = useState<any>([]);
    let [contractDocument, setcontractDocument] = useState<any>([]);
    let [opencontractReleases, setopencontractReleases] = useState(false);
    let [openContractTrackMain, setopenContractTrackMain] = useState(false);

    const closecontractSong = () => { setopenContractSong(false); }
    const closecontractReleases = () => { setopencontractReleases(false); }
    const closeContractTrackMain = () => { setopenContractTrackMain(false); }

    useEffect(() => {
        console.log(MainWizard.data.code)

        if (MainWizard.data.code) {

            WizardServices.contractscontractRefNum(MainWizard.data.code.contractRefNum).then((value: any) => {
                setcontractAdditional(value);

                setcontractStatus("Pending")
            })

        }
    }, []);

    const changeStatus = (e: any, opt: any) => {

        var data = {
            "contractRefNum": e.contractRefNum,
            "contractTitle": e.contractTitle,
            "contractType": e.contractType,
            "contractStatusName": e.contractStatusName,
            "contractStatus": e.contractStatus,

            "accountStatus": e.accountStatus,
            "accountStatusName": e.accountStatusName,
            "accountStatusExt": e.accountStatusExt,
            "accountStatusExtName": e.accountStatusExtName,
            "statementCategory": e.statementCategory,
            "statementStatusName": e.statementStatusName,
            "contractAccountCode": e.contractAccountCode,
            "contractAccount": e.contractAccount,
            "mainEmail": e.mainEmail,
            "payeeStatus": e.payeeStatus,
            "payeeStatusName": e.payeeStatusName,
            "projectCode": e.projectCode,

        }

        console.log(opt)
        console.log(e)
        /*if(opt === "prev"){

            for(var $i=0;$i <contractStatus.length ; $i++){
                if(contractStatus[$i] === e.contractStatusName && (ContractStatus[$i-1] !=null)){                    
                    data.contractStatusName = ContractStatus[$i-1];
                    data.contractStatus = ContractStatusKey[$i-1];

                    contractServices.updateContractStatus(data)
                    .then((res) => {
                        if(res === true){
                            getContract()
                        }
                     })
                    
                }
            }
            
        }else if(opt === "next"){
            
            for(var $i=0;$i <ContractStatus.length ; $i++){

                if((ContractStatus[$i] === e.contractStatusName) && (ContractStatus[$i+1] !=null)){   
                    data.contractStatusName = ContractStatus[$i+1];
                    data.contractStatus = ContractStatusKey[$i+1];
                    
                    contractServices.updateContractStatus(data)
                    .then((res) => {
                        if(res === true){
                            getContract()
                        }
                     })
                    
                }
            }
        } */

    }

    var payloadDocument = {
        pageNumber: 1,
        pageSize: 10,
        ContractRefNum: MainWizard.data.code.contractRefNum
    }

    const openFileListing = () => {
        setClose(!close)
        WizardServices.contractDocument(payloadDocument).then((val: any) => {
            contractDocument = val
            setcontractDocument(contractDocument)
        })
    }

    return (
        <div className="form-format">

            <div className="box-header ws-12 pull-left">
                <h2>Contract Summary</h2>
            </div>

            <div className="form-format ws-12 pLarge">

                <div className="ws-2 text-right ws-2 text-right mt pts text-bold pr">Contract Status</div>


                <div className="ws-10">

                    <a className={contractStatus != null ? "btn-xs text-center ws-3 displayFlex" : "hide"} style={{
                        backgroundColor: CommonUtilities.lookUpTypeList('contractStatusName', contractStatus, 'bgColor'),
                        color: CommonUtilities.lookUpTypeList('contractStatusName', contractStatus, 'fontColor')
                    }}>

                        <i className="icon-circle-left p0 m0 mtss text-center" style={{ color: CommonUtilities.lookUpTypeList('contractStatusName', contractStatus, 'fontColor') }}
                            onClick={() => { changeStatus(conAdditional, "prev") }} />

                        <span style={{ color: CommonUtilities.lookUpTypeList('contractStatusName', contractStatus, 'fontColor') }} className="text-center ws-11">{contractStatus}</span>

                        <i className="icon-circle-right p0 m0 mtss pull-right" style={{ color: CommonUtilities.lookUpTypeList('contractStatusName', contractStatus, 'fontColor') }}
                            onClick={() => { changeStatus(conAdditional, "next") }} />
                    </a>

                    <div className="pull-right">
                        <button className="icon-btn edit ml width90 height35" onClick={() => setopencontractReleases(true)}>Release </button>
                        <button className="icon-btn edit ml width90 height35" onClick={() => setopenContractTrackMain(true)}>Track</button>
                        <button className="icon-btn edit ml width90 height35" onClick={() => setopenContractSong(true)}>Song</button>
                    </div>
                </div>

                <div className='box ws-12 mtxl'>
                    <div className="box-header"> <h2><i className="icon-info "></i><span>Contract Documents</span></h2> </div>

                    <div className='box-content'>

                        <div className="form-format ws-8 ">
                            <label className="control-label" >Contract Ref No.*</label>
                            <div className="label-entries">
                                <input type="text" className="text-uppercase ws-8 " placeholder="Enter contract ref" value={MainWizard.data.code.contractRefNum} disabled={MainWizard.data.code.contractRefNum ? true : false} />

                            </div>
                        </div>

                        <div className="form-format ws-8 ">
                            <label className="control-label">Description</label>
                            <div className="label-entries">
                                <input type="text" className="text-uppercase ws-8" placeholder="Document Details" />
                            </div>
                        </div>

                        <div className="form-format ws-8 ">
                            <label className="control-label">File Upload</label>
                            <div className="label-entries pull-right">
                                <input type="file" className="text-uppercase" placeholder="Document Details" />

                            </div>
                        </div>
                    </div>


                </div>

                <div className='box mt hide'>
                    <div className="box-header ws-12 pull-left">
                        <h2 className='ws-10'>{contractDocument.length} file(s) found</h2>

                        <button className="icon-btn edit btn-xl pull-right" onClick={openFileListing}>
                            <i className={close ? "icon-minus1 " : "icon-plus1"}></i>
                        </button>
                    </div>

                    <div className={close == false ? 'hide' : 'box-content'}>

                        {contractDocument.length == 0 && <div className=" alert alert-info text-center">No records to display  </div>}

                        {contractDocument.length > 0 && <div className="ws-12 allowVscroll">
                            <table className="table ws-12" >
                                <thead>
                                    <tr>
                                        <th >Document Location</th>
                                        <th >Contract Clause</th>
                                        <th >Description</th>
                                        <th >Operation</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Aust,France,Germ,Japan,New Z (AUFRDEJPNZ)</td>
                                        <td>All Formats</td>
                                        <td className="text-right ">2</td>
                                        <td >
                                            <a className="btn-sm icon-btn edit"><i className="icon-edit1"></i></a>
                                            <a className="btn-sm icon-btn delete"><i className="icon-trashcan"></i></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>}

                    </div>

                </div>
                {
                    (() => {

                        if (opencontractReleases) {
                            return <ContractReleases opencontractReleases={true} closecontractReleases={closecontractReleases} data={conAdditional} />
                        }

                        if (openContractTrackMain) {
                            return <ContractAssetLink onChangContractAssetLink={closeContractTrackMain} ContractAssetLinkOpen={openContractTrackMain} type="Tracks" contractDetails={MainWizard.data.code} />
                        }

                        if (openContractSong) {
                            return <ContractAssetLink onChangContractAssetLink={closecontractSong} ContractAssetLinkOpen={openContractSong} type="Songs" contractDetails={MainWizard.data.code} />
                        }
                    })()
                }
            </div>
        </div>
    );
}
